
import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { ShoppingCart } from 'lucide-react';

const HeroSection = () => {
  return (
    <div className="text-center mb-12">
      <motion.h1 
        className="text-3xl md:text-4xl font-bold text-gray-900 mb-2"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        Learn How We Booked 3,300 Sales Meetings & Raised $900,000 In Capital With Cold Email
      </motion.h1>
      
      <motion.p 
        className="text-xl md:text-2xl text-gray-700 mb-2"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        Skip to the top of the waitlist and learn how to book 5-30 sales meetings a day with cold email with the Cold Email Secrets Training Program
      </motion.p>
      
      <motion.div
        className="mt-8 mb-8"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.3 }}
      >
        <img 
          src="/lovable-uploads/a133088b-fa07-4a46-9e59-f6a9882e1411.png" 
          alt="Email campaign analytics dashboard showing event data with metrics like created events (3.3K), completed events (2.4K), and rescheduled events (122)" 
          className="rounded-lg shadow-xl max-w-full mx-auto"
        />
      </motion.div>
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.4 }}
        className="mt-6"
      >
        <a href="https://whop.com/checkout/plan_lgxEwNdJ45OQ3?d2c=true" target="_blank" rel="noopener noreferrer">
          <Button 
            size="lg"
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold text-lg px-8 py-6 h-auto rounded-md animate-pulse-glow"
          >
            <ShoppingCart className="mr-2 h-5 w-5" />
            BUY NOW
          </Button>
        </a>
      </motion.div>
    </div>
  );
};

export default HeroSection;
